"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCssClassByProps = void 0;

var createCssClassByProps = function createCssClassByProps(props) {
  var color = props.color,
      size = props.size,
      fontType = props.fontType,
      kind = props.kind,
      align = props.align,
      segment = props.segment,
      className = props.className,
      display = props.display,
      backgroundColor = props.backgroundColor,
      decoration = props.decoration,
      border = props.border;
  var background = backgroundColor ? "".concat(kind, "-").concat(segment, "--").concat(backgroundColor, "-background") : '';
  var displaycss = display ? "".concat(kind, "--").concat(display) : '';
  var segmentcss = segment ? "".concat(segment) : '';
  var ownCss = className ? " ".concat(className) : '';
  var decorationCss = "".concat(kind, "-decoration--").concat(decoration);
  var borderCss = "".concat(kind, "-border--").concat(border);
  return "".concat(kind, " ").concat(kind, "-").concat(segmentcss, "--").concat(size, " ").concat(kind, "-").concat(segmentcss, "--").concat(fontType, " ").concat(kind, "--").concat(align, " ").concat(kind, "-").concat(segmentcss, "--").concat(color, " ").concat(background).concat(ownCss, " ").concat(displaycss, " ").concat(decorationCss, " ").concat(borderCss);
};

exports.createCssClassByProps = createCssClassByProps;

//# sourceMappingURL=utils.js.map